import { coreAdversaries } from './core';
import { voidAdversaries } from './void';

export type { Adversary, AdversaryFeature } from './types';
export const adversaries = [...coreAdversaries, ...voidAdversaries];
